import cn from 'classnames';

import ArrowIcon from '@/icons/ArrowIcon';

type ButtonCircleProps = {
  arrowFill?: string;
  arrowHeight?: number;
  arrowWidth?: number;
  extraClasses?: string;
  customIcon?: React.ReactNode;
};

const ButtonCircle: React.FC<ButtonCircleProps> = ({
  arrowFill = 'var(--color-brand, currentColor)',
  arrowHeight = 17,
  arrowWidth = 17,
  extraClasses,
  customIcon,
}) => {
  let icon = customIcon;
  if (!customIcon) {
    icon = (
      <ArrowIcon fill={arrowFill} height={arrowHeight} width={arrowWidth} />
    );
  }

  return (
    <span className={cn('button__circle', extraClasses)} aria-hidden>
      <span className="button__arrow button__arrow--first">{icon}</span>
      <span className="button__arrow button__arrow--second">{icon}</span>
    </span>
  );
};

export default ButtonCircle;
